<template>
  <CCard >      
    <CCardBody>       
      <CRow>      
        <CCol sm="12" lg="12" >       
          <div class="content-wrapper">
            <div id="app">
              <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                  <ejs-grid ref='grid' :dataSource='datas' height='500' :allowExcelExport='true'
                    :allowPaging='true' :allowSorting='true' :allowFiltering='true' :allowReordering='true' :allowSelection='true'
                    :toolbar='toolbar' :pageSettings='pageSettings' :filterSettings='filterSettings'
                    :toolbarClick="toolbarClick"  :editSettings='editSettings' @rowSelected="onRowSelected" >                             
                  <e-columns>        
                      <e-column field='import' headerText='重要' width='60' :template='importTemplate'></e-column>           
                      <e-column field='title' headerText='主旨' aria-required="true" width='250'></e-column>              
                      <e-column field='receive' headerText='收件人  ' width='100' ></e-column>   
                      <e-column field='date' headerText='發布時間' width='120' ></e-column>   
                      <e-column field='end_date' headerText='結束時間' width='120'  ></e-column>   
                      <e-column field='user' headerText='發布人員' width='160'></e-column> 
                  </e-columns>
                </ejs-grid>        
              </ejs-tooltip>
            </div>                  
          </div>                
        </CCol>
      </CRow>
      <ejs-toast ref='toastRef' id='toast_type' :position='position'></ejs-toast>   
    </CCardBody>   
  </CCard>
</template>
<style ></style>
<script >

import Vue from "vue";
import { L10n, enableRipple  } from '@syncfusion/ej2-base';
import { DialogUtility } from '@syncfusion/ej2-popups';
import { DialogPlugin, TooltipPlugin } from '@syncfusion/ej2-vue-popups';
import { TextBoxPlugin, NumericTextBoxPlugin  } from '@syncfusion/ej2-vue-inputs';
import { ButtonPlugin, CheckBoxPlugin, RadioButtonPlugin  } from '@syncfusion/ej2-vue-buttons';    
import { DropDownListPlugin } from "@syncfusion/ej2-vue-dropdowns";
import { GridPlugin, DetailRow, PdfExport, ExcelExport, Sort, Edit, Page, Filter, Reorder, Toolbar, Search } from "@syncfusion/ej2-vue-grids";
import zhtwLocalization  from '../language/language.json';
import { ToastComponent } from "@syncfusion/ej2-vue-notifications";

L10n.load(zhtwLocalization);

enableRipple(true);
Vue.use(DialogPlugin);
Vue.use(GridPlugin);    
Vue.use(ButtonPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(TextBoxPlugin);
Vue.use(DropDownListPlugin);
Vue.use(NumericTextBoxPlugin );
Vue.use(RadioButtonPlugin);
Vue.use(TooltipPlugin);
let DialogObj   = undefined;
export default {
name: 'GetMaterials',
components: {
  // 'ejs-button': ButtonComponent,
  'ejs-toast': ToastComponent,
},
data: function() {
  return {
    position: { X: 'Right', Y: "Bottom" },
      datas : [
       
      ],
selectedRowData:null,
      editSettings: { allowEditing: false, allowAdding: false, allowDeleting: false},
      pageSettings: {pageSize: 50, pageSizes: [10,50,100,200], pageCount: 50 },     
      toolbar: [
        { text: '新增', tooltipText: '新增', prefixIcon: 'e-btn-icon e-add e-icons e-icon-left', id: 'Add' },  
        { text: '修改', tooltipText: '修改', prefixIcon: 'e-btn-icon e-edit e-icons e-icon-left', id: 'Edit' },  
        { text: '刪除', tooltipText: '刪除', prefixIcon: 'e-btn-icon e-delete e-icons e-icon-left', id: 'Delete' },  
        { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Export' }, 'Search'],   
      selectionSettings: {type: 'Multiple'},  
      filterSettings: { type: 'CheckBox' },     
      animationSettings: { effect: 'Fade' },
      visible : false,
      freightrules:  { required: true, min: 0, number: true},
      importTemplate: function() {
        return {
          template: Vue.component('importTemplate', {
              
              template: `
                <div>
                    <span v-if="importStatus == true" style="color: red; font-weight: bold; font-size: 18px;">❗</span>
                </div>`,
                data: function () { return { data: {}, inactive: 'Inactive' }; },
                computed: {
              importStatus() {
              // 安全地從 props 拿值
              return this.data && typeof this.data.import !== 'undefined'
                ? this.data.import
                : false;
                }
              }
            })}},
      progessTemplate: function () {
        return {
          template: Vue.component('progessTemplate', {
            template: `<div id="myProgress" class="pbar">
              <div id="myBar" :class="{'bar': true, 'progressdisable': data.status == inactive}" :style="{'width': width}">
                <div id="pbarlabel" class="barlabel" v-html=width ></div>
                </div>
              </div>`,
              data: function () { return { data: {}, inactive: 'Inactive' }; },
            computed: {
              width: function () {  
                return this.data.size + '%';
              }
            }
          })
        }
      },         
    };
},

methods: {    
        toolbarClick: function(args) {
      if (args.item.id == "Export") {
        this.$refs.grid.excelExport({ fileName:'訊息管理.xlsx' });
      }
      if (args.item.id == "Add") { 
        return this.$router.push('/Settings/EditMessage?msgID=add')    
      }
      if (args.item.id  == "Edit") {
        if(this.selectedRowData ==null){
           this.$toast.open({message: '請選擇訊息!', type: "error", duration: 5000, dismissible: true})
          return;
        }
        return this.$router.push(`/Settings/EditMessage?msgID=${this.selectedRowData.msgID}&usercategory=${this.selectedRowData.usercategory}`)     
      }
      if (args.item.id  == "Delete") {
        
        if(this.selectedRowData ==null){
           this.$toast.open({message: '請選擇訊息!', type: "error", duration: 5000, dismissible: true})
          return;
        }
        DialogObj = DialogUtility.confirm({
            title: '刪除資料',
            content: `確認是否要刪除${this.e_selectData}的資料嗎?`,
            okButton: {  text: 'Yes', click: this.Del },
            cancelButton: {  text: 'No', click: this.hide },
            showCloseIcon: true,
            closeOnEscape: true,
            animationSettings: { effect: 'Fade' }
        });
        
      }
    },  
   onRowSelected(args) {
    this.selectedRowData = args.data;
    // 你可以拿來做編輯、跳轉、顯示詳情等用途
  },
  //api
  getMsg: function () {  
    this.axios({
        method: 'get',
        baseURL: Vue.prototype.GLOBAL.baseURL,
        url: `/Message`,
        headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
    })
    .then((response) => {       
      if (!response.data.ok) { this.showMsg(response.data.msg) ;return; }                 
      this.datas = response.data.datas;
      console.log(response.data.datas)
      return; 
    })
    .catch((error) => { 
      this.showMsg(error) 
    })             
  },
   
  Del: function () {  
    DialogObj.hide();
    this.axios({
        method: 'delete',
        baseURL: Vue.prototype.GLOBAL.baseURL,
        url: `/Message?MsgID=${this.selectedRowData.msgID}&&roletype=${this.selectedRowData.usercategory}`,
        headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
    })
    .then((response) => {       
      if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }                 
      this.$refs.toastRef.show( { title: '訊息!', content: response.data.msg, cssClass:  'e-toast-info', icon: 'e-info toast-icons' });
      this.getMsg();
      console.log(response.data.msg)

      
    })
    .catch((error) => { 
      this.showError(error, true) 
    })             
  },
  //error
   showMsg: function (msg) {
        this.$refs.toastRef.show( { title: '錯誤!', content: msg, cssClass: 'e-toast-danger', icon: 'e-info toast-icons' });
      },
  submit:function() {
    this.$emit('onGetMaterialsClose');
  },
  beforeRender: function (args) {
    if (args.target.closest("td")) {
        this.$refs.tooltip.content = args.target.innerText;                
    }
  },   
  pubDoubleClick: function () {  
        this.$refs.modalDialog.show();
    },
    editOkClick: function () {           
        this.upData();         
    },
    valueChange: function () {  
        this.isDataChanged = true;
        this.stTime = null;
    },
    load: function() {   

    },         
 

    actionComplete: function() {                             
    },
    rowSelected: function() {          
    },    
    showError: function(error) {
        if (error.response.status == 400) {
            for(var key in error.response.data.errors){                 
                this.$toast.open({message: error.response.data.errors[key][0] , type: "warning", duration: 5000, dismissible: true}) 
            }
            return;
        }    
        if (error.response.status == 401) {  
            localStorage.removeItem('token'); this.$router.push('/login'); 
            return; 
        }                
        this.$toast.open({message: '系統發生錯誤' + error.response.status, type: "error", duration: 5000, dismissible: true}) 
    }
},
provide: {
  grid: [PdfExport, ExcelExport, Sort , DetailRow, Edit, Page, Toolbar, Filter, Reorder, Search]      
},
created() {
      this.getMsg();
},
mounted() {
  const errmsg = this.$route.query.toastf;
   if(errmsg == undefined){
      return;
    }
    this.$refs.toastRef.show( { title: '訊息!', content: errmsg, cssClass:  'e-toast-info', icon: 'e-info toast-icons' });
},
beforeUpdate() {
  
},
beforeDestroy() {
 
}  
}
</script>